import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/reached-on-error
// A batter receives a reached on error when he reaches base because of a defensive error -- meaning he wouldn't have otherwise reached.
const classifiesAsReachedOnError = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.ReachedOnError.key:
        // TODO not sure how to handle this case, when there is a sacrifice play, but batter manages to reach first base on error
        // based on this play https://www.youtube.com/watch?v=ds9JSt8SlwU, such play (ROE + SAC) for statistical purposes is still treated as sacrifice, because: 
        // A. Pujols still gets only 4 AB in this game (1B in 1st, GO in 3rd, LO in 5th, 1B in 8th) 
        // Fielder gets an error
        // https://www.baseball-reference.com/boxes/TEX/TEX201407100.shtml
        // https://www.mlb.com/gameday/angels-vs-rangers/2014/07/10/381914#game_state=final,lock_state=final,game_tab=play-by-play,game=381914
        // https://www.espn.com/mlb/playbyplay?gameId=340710113
        //case PlateAppearanceResult.SacrificeOnError.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsReachedOnError;